import React, { useState, useRef, useEffect } from 'react';
import styled, { css } from 'styled-components';
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import fetchConfig from '../../Constants/fetch';
import { TutorialsAndFAQ } from '../../components';
import Login from '../Login/Login';
import { X } from '../../Constants/assets';

const InfoInnerContainer = styled.div`
    width: 70%;
    min-height: 700px;
    background: ${props => props.theme.colors.white};
    box-shadow: 0px 0px 24px rgba(0, 0, 0, 0.18);
    border-radius: 8px;
    text-align: center;
    font-family: 'Roboto', sans-serif;
    z-index: 104;
    height: fit-content;
    position: absolute;
    overflow-y: auto;
`;
const BodyContainer = styled.div`
    width: 94%;
    height: 100%;
    margin: 0 auto;
    justify-content: center;
`;

const PageContainer = styled.div`
    display: flex;
    flex-direction: row;
    overflow: hidden;
`;

const SectionContainer = styled.div`
    width: 80%;
    // min-height: 90vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
`;

const FaqSection = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    // margin: 60px 0px 0px -40px;
    overflow-y: auto; /* Allows internal scrolling if content overflows */
    height: 70vh;
`;

const HeaderContent = styled.div`
    margin-top: 30px;
    font-weight: bold;
    display: flex;
    justify-content: center;
    align-items: flex-end;
    flex-direction: row;
    margin-left: 10px;
    justify-content: space-between;
    margin-bottom: 30px;
`;

const Title = styled.h4`
    font-weight: 800;
`;
const SectionTitle = styled.h5`
    font-weight: 500;
`;

const XContainer = styled.div`
    height: 57%;
    cursor: pointer;
`;

const Help = props => {
    const { t } = useTranslation();
    if (props.show) {
        return (
            <>
                <InfoInnerContainer>
                    <BodyContainer>
                        <HeaderContent>
                            <Title>{t('login.help.help')}</Title>
                            <XContainer>
                                <X onClick={() => props.toggleHelp(false)} />
                            </XContainer>
                        </HeaderContent>
                        <PageContainer>
                            <FaqSection>
                                <TutorialsAndFAQ />
                            </FaqSection>
                        </PageContainer>
                    </BodyContainer>
                </InfoInnerContainer>
            </>
        );
    }
    return null;
};

export default Help;
